import React, { Fragment, memo, useCallback, useEffect, useRef } from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import clsx from 'clsx';

import { HeaderTabs } from '_constants/headerConstants';

import { LoginFormType } from '_types/modals.interface';

import { useAppDispatch } from 'store/configureStore';

import {
  actionHandleShowLoginModal,
  actionHandleShowMenuModal,
} from 'store/reducers/modal';

import './style.scss';
import { useHeaderMenuTabs } from './useHeaderMenuTabs';

interface HomePageTabsProps {
  inModal?: boolean;
  withDividers?: boolean;
  className?: string;
  isForUnAuthHomePage?: boolean;
}

const HomePageTabs: React.FC<HomePageTabsProps> = ({
  inModal = false,
  withDividers = false,
  className,
  isForUnAuthHomePage = false,
}) => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const tabRefs = useRef<Map<string, HTMLAnchorElement | null>>(new Map());
  const { tabs: headerTabsConstants } = useHeaderMenuTabs({
    isForUnAuthHomePage,
  });

  const closeModal = useCallback(() => {
    dispatch(actionHandleShowMenuModal(false));
  }, [dispatch]);

  const onLoginClick = useCallback(() => {
    dispatch(actionHandleShowMenuModal(false));
    dispatch(actionHandleShowLoginModal({ formType: LoginFormType.login }));
  }, [dispatch]);

  if (!headerTabsConstants?.length) {
    return null;
  }

  const handleScrollToElement = (to: string) => {
    const element = document.getElementById(to.replace('#', ''));

    const tabElement = tabRefs.current.get(to);
    if (tabElement) {
      tabRefs.current.forEach((ref) => ref?.classList.remove('active'));
      tabElement.classList.add('active');
    }

    if (element) {
      window.scrollTo({
        top: element.offsetTop - 75,
        behavior: 'smooth',
      });
    }
  };

  if (window.location.href.includes('#')) {
    const link = window.location.href.split('/#')[1];
    setTimeout(() => handleScrollToElement(link), 500);
  }

  return (
    <div
      className={clsx('home_tabs', className, {
        'with-dividers': withDividers,
        'in-modal': inModal,
      })}
    >
      {headerTabsConstants?.map((elem: HeaderTabs, index) => (
        <Fragment key={elem.name}>
          <NavLink
            ref={(el) => tabRefs.current.set(elem.path, el)}
            to={elem.path}
            className={({ isActive }) =>
              clsx('home_tabs_item', {
                active:
                  window.location.pathname === elem.path ||
                  window.location.hash === elem.path,
              })
            }
            key={elem.name}
            onClick={(e) => {
              if (elem.path === '#') {
                onLoginClick();
              } else if (elem.path.includes('#')) {
                e.preventDefault();
                window.history.pushState(null, '', elem.path);

                if (window.location.pathname === '/about-us') {
                  navigate(`/${elem.path}`);
                } else {
                  handleScrollToElement(elem.path);
                }
              } else {
                closeModal();
              }
            }}
          >
            {/* <div className="home_tabs_item__icon">{elem.getIcon(tenantStyling?.shades08)}</div> */}
            <div className="home_tabs_item__text">{elem.name}</div>
          </NavLink>

          {withDividers && index !== headerTabsConstants.length - 1 && (
            <div className="tabs-horizontal-divider" />
          )}
        </Fragment>
      ))}
    </div>
  );
};

export default memo(HomePageTabs);
